import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-web-footer',
  templateUrl: './web-footer.component.html',
  styleUrl: './web-footer.component.scss'
})
export class WebFooterComponent implements OnInit {

  constructor() {}
    public currentYear: string = DateTime.now().toFormat('y');

  ngOnInit(): void {
  }
  
}
